document.addEventListener('DOMContentLoaded', () => {
  // MEGAMENU

  fetchMegaColl();

  function fetchMegaColl() {
    document
      .querySelectorAll('.mega-nav .mega-menu__link--active')
      .forEach((e) => {
        fetchCollection(e);
      });
    document.querySelectorAll('.mega-nav .mega-menu__link').forEach((e) => {
      e.addEventListener('click', (i) => {
        i.preventDefault();

        document
          .querySelectorAll('.mega-nav .mega-menu__link')
          .forEach((ee) => {
            ee.classList.remove('mega-menu__link--active');
          });

        if (!i.currentTarget.classList.contains('mega-menu__link--active')) {
          i.currentTarget.classList.add('mega-menu__link--active');
        }
        fetchCollection(i.currentTarget);
      });
    });
  }

  function megaSlide() {
    const slidesContainer = document.querySelectorAll('.mega-slider > .grid');
    var scrollStatus = 0;

    slidesContainer.forEach((e) => {
      const slide = e.children[0];
      const parent = e.closest('.mega-slider');
      const nextPrevButton = parent.querySelectorAll('.slider-button');

      nextPrevButton.forEach((b) => {
        b.addEventListener('click', (i) => {
          const slideWidth = slide.clientWidth;
          if (i.currentTarget.classList.contains('slider-button--next')) {
            e.scrollLeft += slideWidth;
          } else {
            e.scrollLeft -= slideWidth;
          }
        });
      });
    });
  }

  function fetchCollection(e) {
    var handle = e.dataset.collection;

    fetch(`/collections/${handle}?view=megamenu`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const fragment = document.createRange().createContextualFragment(html);
        var megaContainer = e
          .closest('.mega-menu__content')
          .querySelector('.collections-mega-item');
        megaContainer.innerHTML = '';
        megaContainer.appendChild(html.querySelector('.mega-contents'));
        megaSlide();
      });
  }


  document.querySelectorAll('.upsell-item .select__select').forEach((e) => {
    document.addEventListener('change', function (e) {
      var t = e.target.closest('.upsell-item');
      if (t) {
        var r = t.querySelector('.product-data').textContent,
          a = JSON.parse(r),
          n = t.querySelector('[name="id"]'),
          c = t.querySelector('.select__select'),
          i = a.filter((e) => e.option1 == c.value),
          l = t.querySelector('.media img');
        null != i[0].featured_image && (l.src = i[0].featured_image.src),
          (n.value = i[0].id);
      }
    });
  });

  document.getElementById('Search-In-Modal-2').blur(),
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
      ? document.querySelectorAll('.card-media-desktop').forEach((e) => {
          e.remove();
        })
      : (document.querySelectorAll('.card-media-mobile').forEach((e) => {
          e.remove();
        }),
        document.querySelectorAll('.counter').forEach((e) => {
          var t = () => {
            var r = +e.getAttribute('data-upto'),
              a = +e.innerText,
              n = r / 200;
            a < r
              ? ((e.innerText = Math.ceil(a + n)), setTimeout(t, 1))
              : (e.innerText =
                  ((e) => {
                    if ((e = e.toString().replace(/[^0-9.]/g, '')) < 1e3)
                      return e;
                    var t,
                      r = [
                        { v: 1e3, s: 'K' },
                        { v: 1e6, s: 'M' },
                        { v: 1e9, s: 'B' },
                        { v: 1e12, s: 'T' },
                        { v: 1e15, s: 'P' },
                        { v: 1e18, s: 'E' },
                      ];
                    for (t = r.length - 1; t > 0 && !(e >= r[t].v); t--);
                    return (
                      (e / r[t].v)
                        .toFixed(2)
                        .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + r[t].s
                    );
                  })(r) + '+');
          };
          t();
        }));
});
